var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { AvatarWrapper, Image, AvatarContent, Initials } from './style';
import { getInitials } from '../utils';
var Avatar = (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Avatar.prototype.render = function () {
        var _a = this.props, size = _a.size, fullName = _a.fullName, customSize = _a.customSize, customFontSize = _a.customFontSize;
        var isImg = this.props.src && !this.props.hideAvatar;
        return (_jsxs(AvatarWrapper, __assign({ style: this.props.style, size: size, customSize: customSize }, { children: [_jsxs("div", __assign({ style: {
                        display: 'flex'
                    } }, { children: [_jsx(Image, __assign({ as: isImg ? 'img' : 'div', opacity: this.props.opacity, size: size, customSize: customSize, "data-test-id": this.props.src && !this.props.hideAvatar
                                ? this.props['data-test-id']
                                : undefined }, (isImg
                            ? {
                                alt: 'user avatar',
                                src: this.props.src
                            }
                            : {}))), !this.props.hideInitials &&
                            (!this.props.src || this.props.hideAvatar) && (_jsx(Initials, __assign({ size: size, customSize: customSize, customFontSize: customFontSize, "data-test-id": this.props['data-test-id'] }, { children: getInitials(fullName) })))] })), _jsx(AvatarContent, __assign({ style: this.props.contentStyle }, { children: this.props.children }))] })));
    };
    return Avatar;
}(React.Component));
export default Avatar;
export { AvatarWrapper };
//# sourceMappingURL=index.js.map